import './screen-saver-overlay.scss';

/**
 * version    1.0
 * class      <type> (ScreenSaver)
 * classdesc  Component that manage the screen saver overlay
 * */
export class ScreenSaverOverlay {}
